module.exports = __webpack_public_path__ + "img/594.72493761.png";